export enum CreditCardType {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  AMEX = 'AMEX',
  DISCOVER = 'DISCOVER',
  DINERS = 'DINERS',
  JCB = 'JCB',
  CHINA_UNION_PAY = 'CHINA_UNION_PAY',
  NOT_SET = 'UNDEFINED',
}
